<div
  class="modal-container saved-carts-list-modal-container restore"
  [ngClass]="deviceDetectorService.isMobile() ? 'reorderMobile' : ''"
>
  <div class="modal-content">
    <div class="modal-header d-flex align-items-center">
      <h4 class="modal-title" *ngIf="!reorder">{{ 'cart.savedCartsModal.title' | cxTranslate }}</h4>
      <h4 class="modal-title" *ngIf="reorder">{{ 'cart.reorder.title' | cxTranslate }}</h4>
      <button
        type="button"
        class="close"
        aria-label="Close"
        (click)="closeModal('Cross click')"
        [disabled]="restoreInprogress"
      >
        <mat-icon svgIcon="modal-x-icon"></mat-icon>
      </button>
    </div>

    <form novalidate [formGroup]="restoreCartModalForm">
      <div class="modal-body">
        <h3 *ngIf="!reorder && checkIsMobileAndNoActiveCart()">{{ 'cart.savedCartsModal.subtitle' | cxTranslate }}</h3>
        <h3 *ngIf="activeCartCount > 0 && reorder">
          {{ 'cart.reorder.subtitle' | cxTranslate }}
        </h3>
        <p *ngIf="!reorder">
          {{ 'cart.savedCartsModal.desc' | cxTranslate }}
        </p>
        <p *ngIf="activeCartCount > 0 && reorder; else emptyActiveCartCount">
          {{ 'cart.reorder.desc' | cxTranslate }}
        </p>
        <ng-template #emptyActiveCartCount>
          <p *ngIf="reorder" [innerHTML]="'cart.reorder.descNonActive' | cxTranslate : { orderNo: cartId }"></p>
        </ng-template>
        <div class="cart-details-container d-flex flex-row flex-wrap" *ngIf="activeCartCount > 0 && reorder">
          <span class="attribute">{{ 'cart.savedCartsModal.attrs.name' | cxTranslate }}</span>
          <span class="value text-break">{{ cartName }}</span>
          <span class="attribute">{{ 'cart.savedCartsModal.attrs.id' | cxTranslate }}</span>
          <span class="value">{{ cartId }}</span>
          <span class="attribute" *ngIf="cartTotalItems">{{ 'cart.savedCartsModal.attrs.number' | cxTranslate }}</span>
          <span class="value" *ngIf="cartTotalItems">{{ cartTotalItems }}</span>
        </div>
        <div class="cart-details-container d-flex flex-row flex-wrap" *ngIf="!reorder">
          <span class="attribute">{{ 'cart.savedCartsModal.attrs.name' | cxTranslate }}</span>
          <span class="value text-break">{{ cartName }}</span>
          <span class="attribute">{{ 'cart.savedCartsModal.attrs.id' | cxTranslate }}</span>
          <span class="value">{{ cartId }}</span>
          <span class="attribute" *ngIf="cartTotalItems">{{ 'cart.savedCartsModal.attrs.number' | cxTranslate }}</span>
          <span class="value" *ngIf="cartTotalItems">{{ cartTotalItems }}</span>
        </div>
        <div class="cart-details-container-has-active-cart" *ngIf="activeCartCount > 0">
          <p [innerHTML]="'cart.savedCartsModal.activeCart.desc' | cxTranslate"></p>
          <div class="cart-details-container-confirm-save">
            <mat-checkbox [disableRipple]="true" formControlName="confirmSave" [color]="'primary'">
              {{ 'cart.savedCartsModal.activeCart.checkbox' | cxTranslate }}
            </mat-checkbox>
            <p *ngIf="restoreCartModalForm.value.confirmSave">
              {{ 'cart.savedCartsModal.activeCart.inputLabel' | cxTranslate }}
            </p>
            <mat-form-field *ngIf="restoreCartModalForm.value.confirmSave" appearance="outline" class="w-100 mt-3">
              <mat-label>{{ 'cart.savedCartsModal.activeCart.inputPlaceholders' | cxTranslate }}</mat-label>
              <input
                #cartName
                matInput
                [placeholder]="'cart.savedCartsModal.activeCart.inputPlaceholders' | cxTranslate"
                formControlName="cartNameInput"
                maxlength="255"
              />
            </mat-form-field>
          </div>
        </div>
      </div>
      <div
        class="modal-footer justify-content-sm-between justify-content-md-end"
        [class.modal-footer-cart-exists]="activeCartCount > 0 && reorder"
      >
        <button type="button" class="btn secondary-btn" (click)="closeModal('Cross click')">
          {{ 'cart.savedCartsModal.cancel' | cxTranslate }}
        </button>
        <button
          type="button"
          class="btn primary-btn"
          (click)="onRestoreSavedCart(cartTotalItems)"
          [class.nl-button]="customizeModalButtons(activeLanguage$ | async, reorder)"
          [class.disabled]="!restoreCartModalForm.valid"
          [disabled]="!restoreCartModalForm.valid"
          [class.disabled]="restoreInprogress"
          [disabled]="restoreInprogress"
          [ngClass]="{
            rotating: restoreInprogress
          }"
        >
          <ng-container *ngIf="!restoreInprogress">
            <ng-container *ngIf="!reorder">
              {{ 'cart.savedCartsModal.restore' | cxTranslate }}
            </ng-container>
            <ng-container *ngIf="reorder">
              {{ 'cart.savedCartsModal.reorder' | cxTranslate }}
            </ng-container>
          </ng-container>
        </button>
      </div>
    </form>
  </div>
</div>
